// Cmd-Parsing für Exec-Console.
// Master-API erwartet string[]. Simple Whitespace-Split — kein Shell-Quoting.
// Wer komplexere Cases braucht: Advanced-Mode mit JSON-Array.

export function splitCmd(input: string): string[] {
  return input
    .trim()
    .split(/\s+/)
    .filter((s) => s.length > 0);
}

export interface ParseResult {
  ok: boolean;
  value?: string[];
  error?: string;
}

export function parseJsonCmd(input: string): ParseResult {
  const trimmed = input.trim();
  if (trimmed.length === 0) return { ok: false, error: "leer" };
  try {
    const parsed = JSON.parse(trimmed);
    if (!Array.isArray(parsed)) return { ok: false, error: "muss ein JSON-Array sein" };
    if (parsed.length === 0) return { ok: false, error: "Array ist leer" };
    if (!parsed.every((s) => typeof s === "string" && s.length > 0)) {
      return { ok: false, error: "alle Elemente müssen non-empty Strings sein" };
    }
    return { ok: true, value: parsed };
  } catch (e) {
    return { ok: false, error: `Ungültiges JSON: ${(e as Error).message}` };
  }
}

export function parseEnvJson(input: string): { ok: true; value: Record<string, string> | undefined } | { ok: false; error: string } {
  const trimmed = input.trim();
  if (trimmed.length === 0) return { ok: true, value: undefined };
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
      return { ok: false, error: "muss ein JSON-Objekt sein" };
    }
    const obj = parsed as Record<string, unknown>;
    for (const [k, v] of Object.entries(obj)) {
      if (typeof v !== "string") return { ok: false, error: `Wert für "${k}" muss ein String sein` };
    }
    return { ok: true, value: obj as Record<string, string> };
  } catch (e) {
    return { ok: false, error: `Ungültiges JSON: ${(e as Error).message}` };
  }
}
